import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdmin, homeForRole, mayVisit } from '../utils/roles';

/**
 * Existing route wrapper. With a path it checks all role allowlists; without one it retains the
 * older admin-only behavior. The backend independently enforces each API's tenancy boundary.
 */
export default function RequireAdmin({ children, path }) {
  const { user } = useAuth();
  if (path ? !mayVisit(user, path) : !isAdmin(user)) {
    return <Navigate to={homeForRole(user)} replace />;
  }
  return children;
}
